import './meevya-cart-protection.js?v=20261023-fluid-1';
import { CartLinesUpdateEvent } from '@shopify/events';

let pending = false;
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('meevya-cart-extra__form')) return;
  event.preventDefault();
  if (pending || document.documentElement.hasAttribute('data-meevya-cart-pending') || !form.reportValidity()) return;
  pending = true;
  document.documentElement.setAttribute('data-meevya-cart-pending', '');
  const status = form.querySelector('[data-meevya-extra-status]');
  if (status) status.textContent = status.dataset.pending;
  const buttons = [...document.querySelectorAll('[data-meevya-extra-add], .cart__checkout-button')];
  const previous = buttons.map(button => button.disabled);
  buttons.forEach(button => { button.disabled = true; });
  let didAdd = false;
  try {
    const body = new FormData(form);
    const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node => node.dataset.sectionId))].slice(0, 5);
    if (sectionIds.length) body.set('sections', sectionIds.join(','));
    body.set('sections_url', window.location.pathname);
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
    const added = await response.json();
    if (!response.ok || added.status) throw new Error('add_failed');
    didAdd = true;
    const snapshot = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!snapshot.ok) throw new Error('refresh_failed');
    const cart = await snapshot.json();
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: String(body.get('id')), quantity: 1 }], promise: deferred.promise }));
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: added.sections, source: 'meevya-cart-extra', items: cart.items } });
    document.dispatchEvent(new CustomEvent('meevya:cart-extra-added', { detail: { variantId: String(body.get('id')), currency: cart.currency } }));
    if (status) status.textContent = status.dataset.success;
  } catch {
    if (didAdd) {
      window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    } else if (status) {
      status.textContent = status.dataset.error;
    }
  } finally {
    pending = false;
    document.documentElement.removeAttribute('data-meevya-cart-pending');
    buttons.forEach((button, index) => {
      if (button.isConnected) button.disabled = didAdd && form.contains(button) && button.hasAttribute('data-meevya-extra-add') ? true : previous[index];
    });
  }
}, true);

document.addEventListener('click', (event) => {
  if (pending && event.target instanceof Element && event.target.closest('[name="checkout"], a[href*="/checkout"], .additional-checkout-buttons')) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

document.addEventListener('submit', (event) => {
  if (pending && event.target instanceof HTMLFormElement && event.target.matches('.cart-form, form[action$="/cart"]')) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);


